import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/workExperienceResource";
/*import RHFSelect from "components/forms/RHFSelect";*/

export default function TabForm({ register, errors, control }) {
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={8}>
                <DTextField
                    name={resource.fields.employerName.name}
                    label={resource.fields.employerName.label}
                    required={resource.fields.employerName.required}
                    options={resource.fields.employerName.options ?? []}
                    error={!!errors.employerName}
                    {...register(resource.fields.employerName.name)}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.position.label}
                    required={resource.fields.position.required}
                    {...register(resource.fields.position.name)}
                    error={!!errors.position}
                    helperText={errors.position?.message}
                    type={resource?.fields?.position?.type}
                />
            </GridItem>

            <GridItem xs={12} md={12}>
                <DTextField
                    label={resource.fields.status.label}
                    {...register(resource.fields.status.name)}
                    error={!!errors.status}
                    helperText={errors.status?.message}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.endDate.label}
                    InputLabelProps={{ shrink: true }}
                    {...register(resource.fields.endDate.name)}
                    error={!!errors.endDate}
                    helperText={errors.endDate?.message}
                    type={resource?.fields?.endDate?.type}
                />
            </GridItem>
            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.payRate.label}
                    {...register(resource.fields.payRate.name)}
                    error={!!errors.payRate}
                    helperText={errors.payRate?.message}
                />
            </GridItem>
            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.isGoverment.label}
                    {...register(resource.fields.isGoverment.name)}
                    error={!!errors.isGoverment}
                    helperText={errors.payRate?.isGoverment}
                    select
                    options={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" }
                    ]}
                />
            </GridItem>
        </GridContainer>
    );
}
